import type React from 'react';

import { SipIdentityExtensionUpdateFields } from '@ragu-components/ord-types';
import { useTranslate } from 'react-admin';

import { OrdPasswordInput } from 'src/components/formInputs';
import { useGetPasswordPolicy } from 'src/hooks/useGetPasswordPolicy';

import type { OrdPasswordInputProps } from 'src/components/formInputs';

export const SipIdentitiesPassword = ({
  source = SipIdentityExtensionUpdateFields.password,
  ...props
}: Partial<OrdPasswordInputProps>): React.ReactElement => {
  const { isLoading, passwordPolicy } = useGetPasswordPolicy({ cosType: 'sip_default' });

  const translate = useTranslate();

  return (
    <OrdPasswordInput
      isLoading={isLoading}
      source={source}
      tooltip={translate('resources.sip_identities.operations.genPassword')}
      passwordPolicy={passwordPolicy}
      helperText={false}
      {...props}
    />
  );
};
